import { Type } from 'typebox';
import { createFallbackStringEnumCodec } from '../../utils/fallback-string-enum-codec.js';
import { TypeBoxShortIsoCalendarDateFormat } from '../../utils/register-typebox-short-iso-calendar-date-format.js';
export const AbsenceTypes = {
    vacation: 'vacation',
    sick: 'sick',
    excused: 'excused',
    unknown: 'unknown'
};
export const AbsenceType = Type.Union([
    Type.Literal(AbsenceTypes.vacation),
    Type.Literal(AbsenceTypes.sick),
    Type.Literal(AbsenceTypes.excused),
    Type.Literal(AbsenceTypes.unknown)
]);
export const AbsenceTypeCodec = createFallbackStringEnumCodec(AbsenceTypes, AbsenceTypes.unknown);
export const Absence = Type.Object({
    type: AbsenceTypeCodec,
    clientUpdateTimestamp: Type.Number(),
    startDate: Type.String({ format: TypeBoxShortIsoCalendarDateFormat }),
    returnDate: Type.String({ format: TypeBoxShortIsoCalendarDateFormat }),
    deleted: Type.Optional(Type.Boolean()),
    reason: Type.Optional(Type.String({ minLength: 1 })),
    excused: Type.Boolean()
});
